import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.set-prototype-of";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/* eslint-disable  react/jsx-no-bind */
import React, { Component } from 'react';
import PropTypes from 'prop-types'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import get from 'lodash/get'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import isEmpty from 'lodash/isEmpty'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import omit from 'lodash/omit';
import Button from '@nerdwallet/react-button';
import Input from '@nerdwallet/react-input';
import Link from '@nerdwallet/react-link';
import { StarRatingInput as StarRating } from '@nerdwallet/react-star-rating';
import Textarea from '@nerdwallet/react-textarea';
import InputGroup from '@nerdwallet/react-input-group';
import LoginPopover from './login-popover';
import { DEFAULT_USER_IMAGE } from './images';
import { setTrk, TrkTag, TrkElement } from '../trk-helper';
import { ElementInteraction, formInputChanged as trackFormInputChanged, formSubmit as trackFormSubmit } from '../tracking';
var propTypes = {
  gigya: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
    user: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
    postedComment: PropTypes.object
  }),
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  streamID: PropTypes.string,
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  error: PropTypes.string,
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  handlePost: PropTypes.func,
  logout: PropTypes.func.isRequired,
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  shouldShowTabDesign: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  closeWriteReview: PropTypes.func
};
var defaultProps = {
  gigya: {}
};
var initialValidationState = {
  isValid: true,
  errors: [],
  feedback: []
};
var initialState = {
  title: {
    value: '',
    validation: initialValidationState
  },
  body: {
    value: '',
    validation: initialValidationState
  },
  rating: {
    value: 0,
    validation: initialValidationState
  },
  // If user has a previously posted comment, show it instead of review form
  submitted: false,
  isValid: false,
  showLoginPopover: false
};
var ERROR_MESSAGES = {
  title: 'Title can’t be blank',
  body: 'Description can’t be blank',
  rating: true
};

var CommentBox =
/*#__PURE__*/
function (_Component) {
  _inherits(CommentBox, _Component);

  function CommentBox(props) {
    var _this;

    _classCallCheck(this, CommentBox);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CommentBox).call(this, props));
    _this.validateInput = _this.validateInput.bind(_assertThisInitialized(_this));
    _this.validateInputs = _this.validateInputs.bind(_assertThisInitialized(_this));
    _this.handlePostClick = _this.handlePostClick.bind(_assertThisInitialized(_this));
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.handleLogout = _this.handleLogout.bind(_assertThisInitialized(_this));
    _this.postComment = _this.postComment.bind(_assertThisInitialized(_this));
    _this.hideLoginPopover = _this.hideLoginPopover.bind(_assertThisInitialized(_this));
    _this.handleLoginPopoverClick = _this.handleLoginPopoverClick.bind(_assertThisInitialized(_this));
    _this.state = _objectSpread({}, initialState, {
      // If user has a previously posted comment, show it instead of review form
      submitted: !!get(props, 'gigya.postedComment')
    });
    return _this;
  }

  _createClass(CommentBox, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var oldComment = get(this.props, 'gigya.postedComment');
      var comment = get(nextProps, 'gigya.postedComment');

      if (!oldComment && comment) {
        // Display previous posted comment
        this.setState(_objectSpread({}, this.state, {
          title: _objectSpread({}, this.state.title, {
            value: comment.commentTitle
          }),
          body: _objectSpread({}, this.state.body, {
            value: comment.commentText
          }),
          rating: _objectSpread({}, this.state.rating, {
            value: get(comment, 'ratings._overall')
          }),
          submitted: true
        }));
      } else if (oldComment && !comment) {
        // Show forms if user logs out
        this.setState(initialState);
      }
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(field, e) {
      var _this2 = this;

      var value = get(e, 'target.value', e);
      this.setState(_objectSpread({}, this.state, _defineProperty({}, field, _objectSpread({}, this.state[field], {
        value: value
      }))), function () {
        _this2.validateInput(value, ERROR_MESSAGES[field]);

        trackFormInputChanged({
          formName: 'nw-comments__comment-form',
          inputType: field === 'rating' ? 'BUTTON' : 'TEXT',
          fieldName: field,
          fieldValue: value
        });
      });
    } // eslint-disable-next-line class-methods-use-this -- directive added automatically by Shepherd migration

  }, {
    key: "createFailedValidationObject",
    value: function createFailedValidationObject(error) {
      return {
        isValid: false,
        errors: [error],
        feedback: [error]
      };
    }
  }, {
    key: "validateInput",
    value: function validateInput(value, error) {
      if (isEmpty(value)) {
        return this.createFailedValidationObject(error);
      }

      return initialValidationState;
    }
  }, {
    key: "validateInputs",
    value: function validateInputs() {
      var _this$state = this.state,
          title = _this$state.title,
          body = _this$state.body,
          rating = _this$state.rating;
      var isValid = !isEmpty(title.value) && !isEmpty(body.value) && rating.value !== 0;

      var newState = _objectSpread({}, this.state, {
        title: _objectSpread({}, this.state.title, {
          validation: this.validateInput(title.value, ERROR_MESSAGES.title)
        }),
        body: _objectSpread({}, this.state.body, {
          validation: this.validateInput(body.value, ERROR_MESSAGES.body)
        }),
        rating: _objectSpread({}, this.state.rating, {
          validation: this.validateInput(rating.value, ERROR_MESSAGES.rating)
        }),
        isValid: isValid
      });

      this.setState(newState);
      return isValid;
    }
  }, {
    key: "postComment",
    value: function postComment() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      this.props.handlePost({
        UID: get(this.props, 'gigya.user.UID'),
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        streamID: this.props.streamID,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        title: this.state.title.value,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        body: this.state.body.value,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        rating: {
          _overall: this.state.rating.value
        },
        provider: params.provider
      });
      trackFormSubmit({
        formName: 'nw-comments__comment-form',
        inputType: 'SUBMIT'
      });
    }
  }, {
    key: "handlePostClick",
    value: function handlePostClick(e) {
      e.preventDefault();
      var gigya = this.props.gigya;
      var isValid = this.validateInputs(); // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration

      var isLoggedIn = gigya.auth.loginToken.get() !== null; // eslint-disable-next-line no-empty -- directive added automatically by Shepherd migration

      if (!isValid) {} else if (!isLoggedIn) {
        this.setState({
          showLoginPopover: true
        });
      } // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      else if (isValid && this.props.handlePost) {
          this.postComment();
        }
    }
  }, {
    key: "hideLoginPopover",
    value: function hideLoginPopover() {
      this.setState({
        showLoginPopover: false
      });
    }
  }, {
    key: "handleLoginPopoverClick",
    value: function handleLoginPopoverClick(provider) {
      // Pass login provider to use for login before posting comment
      this.postComment({
        provider: provider
      });
      this.hideLoginPopover();
    }
  }, {
    key: "handleLogout",
    value: function handleLogout(e) {
      e.preventDefault(); // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      this.props.logout();
      this.setState(initialState);
    }
  }, {
    key: "renderLoggedInUser",
    value: function renderLoggedInUser() {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      var user = this.props.gigya.user;
      return user && React.createElement("div", {
        className: "nw-comment-box__user"
      }, React.createElement("span", {
        className: "nw-comment-box__user-name"
      }, user.firstName ? "Hello, ".concat(user.firstName, " ").concat(user.lastName) : ''), "(", React.createElement(ElementInteraction, {
        type: "CLICK",
        id: "nw-comment-box__user-logout",
        elementName: "nw-comment-box__user-logout",
        sectionCategory: "comment-box",
        elementCategory: "button",
        elementDomType: "button"
      }, React.createElement(Link, {
        className: "nw-comment-box__user-logout",
        onClick: this.handleLogout
      }, "Logout")), ")");
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _params;

      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      if (this.state.submitted) {
        return React.createElement("header", {
          className: "nw-comment-box__header"
        }, React.createElement("h4", {
          className: "nw-comment-box__header-title"
        }, "Your review"));
      }

      var url = setTrk({
        url: '/blog/nerdwallets-posting-guidelines',
        params: (_params = {}, _defineProperty(_params, TrkTag.location, 'nw-comments__comment-form'), _defineProperty(_params, TrkTag.element, TrkElement.hyperlink), _params)
      });
      return React.createElement("header", {
        className: "nw-comment-box__header"
      }, React.createElement("h4", {
        className: "nw-comment-box__header-title"
      }, "Write a review"), React.createElement(Link, {
        className: "nw-comment-box__header-link",
        target: "_blank",
        rel: "noopener noreferrer",
        href: url
      }, "Read Our Posting Guidelines"));
    }
  }, {
    key: "renderRating",
    value: function renderRating() {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      if (this.state.submitted) {
        return React.createElement("div", {
          className: "nw-comment-box__rating-stars"
        }, React.createElement("div", {
          className: "nw-comment-box__rating-header"
        }, "My Rating:"), React.createElement(StarRating, {
          id: "gigya-commented-comment-box" // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          ,
          rating: this.state.rating.value,
          className: "nw-comment-box__rating-value"
        }));
      }

      return React.createElement("div", {
        className: "nw-comment-box__rating-stars"
      }, this.props.shouldShowTabDesign ? React.createElement("span", {
        className: "nw-comment-box__rating-header"
      }, "Rate it") : React.createElement("div", {
        className: "nw-comment-box__rating-header"
      }, "Overall Rating:"), React.createElement(StarRating, {
        id: "gigya-comment-box",
        maxRating: 5 // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        ,
        rating: this.state.rating.value,
        error: !get(this.state, 'rating.validation.isValid'),
        onChange: this.handleInputChange.bind(null, 'rating'),
        className: "nw-comment-box__rating-value"
      }));
    }
  }, {
    key: "renderFields",
    value: function renderFields() {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      if (this.state.submitted) {
        return React.createElement("div", null, React.createElement("div", {
          className: "nw-comment-box__summary nw-comment-box__field--submitted"
        }, "Title:", this.state.title.value), React.createElement("div", {
          className: "nw-comment-box__textarea--submitted nw-comment-box__field--submitted"
        }, "Review:", this.state.body.value));
      }

      var shouldShowTabDesign = this.props.shouldShowTabDesign;
      return React.createElement("div", null, React.createElement(InputGroup, {
        error: !get(this.state, 'title.validation.isValid', true),
        help: get(this.state, 'title.validation.feedback[0]'),
        className: "nw-comment-box__summary",
        label: shouldShowTabDesign && 'Title',
        input: React.createElement(Input // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        , _extends({}, omit(this.state.title, 'validation'), {
          error: !get(this.state, 'title.validation.isValid', true),
          placeholder: "Enter a title for your review",
          onChange: this.handleInputChange.bind(null, 'title'),
          fullWidth: true
        }))
      }), React.createElement(InputGroup, {
        error: !get(this.state, 'body.validation.isValid', true),
        help: get(this.state, 'body.validation.feedback[0]'),
        className: "nw-comment-box__textarea",
        label: shouldShowTabDesign && 'Review',
        input: React.createElement(Textarea // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        , _extends({}, omit(this.state.body, 'validation'), {
          error: !get(this.state, 'body.validation.isValid', true),
          placeholder: "Write your review",
          onChange: this.handleInputChange.bind(null, 'body'),
          fullWidth: true
        }))
      }));
    }
  }, {
    key: "renderError",
    value: function renderError() {
      return (// eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        this.props.error && // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        React.createElement("div", {
          className: "nw-comment-box__error"
        }, this.props.error)
      );
    }
  }, {
    key: "renderLoginPopover",
    value: function renderLoginPopover() {
      return (// eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        this.state.showLoginPopover && React.createElement(ElementInteraction, {
          id: "nw-comment-box__login-popover",
          elementName: "nw-comment-box__login-popover",
          sectionCategory: "comments",
          elementCategory: "popover"
        }, React.createElement(LoginPopover, {
          onClick: this.handleLoginPopoverClick,
          onClose: this.hideLoginPopover
        }))
      );
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      return React.createElement("footer", {
        className: "nw-comment-box__footer"
      }, !this.state.submitted ? [this.props.shouldShowTabDesign ? React.createElement("div", {
        key: "0"
      }, this.renderLoginPopover()) : null, React.createElement("div", {
        className: "nw-comment-box__submit-buttons",
        key: "1"
      }, this.props.shouldShowTabDesign ? React.createElement(Link, {
        color: "green",
        className: "nw-comment-box__cancel" // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        ,
        onClick: this.props.closeWriteReview
      }, "Cancel") : null, React.createElement(ElementInteraction, {
        type: "CLICK",
        id: "nw-comment-box__post",
        elementName: "nw-comment-box__post",
        sectionCategory: "comments",
        elementCategory: "button",
        elementDomType: "button"
      }, React.createElement("span", null, React.createElement(Button, {
        className: "nw-comment-box__post",
        onClick: this.handlePostClick // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        ,
        primary: this.props.shouldShowTabDesign
      }, "Post"))))] : null, !this.props.shouldShowTabDesign ? this.renderLoginPopover() : null);
    }
  }, {
    key: "render",
    value: function render() {
      var gigya = this.props.gigya;
      var userImageURL = get(gigya, 'user.thumbnailURL', DEFAULT_USER_IMAGE);
      return React.createElement("div", {
        className: "nw-comment-box"
      }, this.renderHeader(), this.renderLoggedInUser(), React.createElement("div", {
        className: "nw-comment-box__user"
      }, React.createElement("div", {
        className: "nw-comment-box__user-photo"
      }, React.createElement("img", {
        className: "nw-comment-box__user-image",
        alt: "user avatar",
        src: userImageURL
      })), this.renderRating()), React.createElement("section", {
        className: "nw-comment-box__fields"
      }, this.renderFields(), this.renderError()), this.renderFooter());
    }
  }]);

  return CommentBox;
}(Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


export { CommentBox as default };
CommentBox.displayName = 'Comment Box'; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

CommentBox.propTypes = propTypes; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

CommentBox.defaultProps = defaultProps;